import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiToggleButtonGroup = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          padding: spacing(1.25),
          borderRadius: misc.borderRadius(2),
          gap: 0,
          backgroundColor: palette.alternative.main,

          '& .MuiToggleButton-root': {
            border: 0,

            '&:not(:first-of-type)': {
              borderLeft: 0,
            },
          },
        },
        groupedHorizontal: {
          marginLeft: 0,
        },
      },
    },
  }) satisfies ComponentCreation
